<template functional>
  <div :class="[`status-badge status-badge--is-${$options.statusAsKebabCase(props.status, props.map)} ${data.staticClass || ''}`]">
    {{ $options.labelAsLowerCase(props.label || props.status) }}
  </div>
</template>

<script>
import { upperFirst, lowerCase, kebabCase } from 'lodash'

export default {
  name: 'BaseStatusBadge',

  props: {
    label: {
      required: false,
      type: String
    },
    status: {
      required: true,
      type: String
    },
    map: {
      type: Object,
      default: null
    }
  },

  labelAsLowerCase (label) {
    return upperFirst(lowerCase(label))
  },

  statusAsKebabCase (status, map = null) {
    return map ? map[kebabCase(status)] : kebabCase(status)
  }
}
</script>
